<style >
	.limit-str {
		overflow-wrap: break-word;
		word-wrap: break-word;
		word-break: break-word;
	}
</style>
<template>
	<section class="vx-row">
		<div class="vx-col w-full">
			<div class="vx-row">
				<div class="vx-col w-full md:w-1/3 mb-6 md:mb-0">
					<!-- Image -->
					<div class="mb-6 ">
						<vx-card class="bg-primary px-4 lg:px-12">
						<!-- Photo Profile -->
						<div class="w-full flex justify-center mb-6">
							<svg v-if="myProfile.file === null" viewBox="0 0 212 212" class="w-32 rounded-full mx-auto flex justify-center"><path fill="#DFE5E7" class="background" d="M106.251.5C164.653.5 212 47.846 212 106.25S164.653 212 106.25 212C47.846 212 .5 164.654.5 106.25S47.846.5 106.251.5z"></path><g fill="#FFF"><path class="primary" d="M173.561 171.615a62.767 62.767 0 0 0-2.065-2.955 67.7 67.7 0 0 0-2.608-3.299 70.112 70.112 0 0 0-3.184-3.527 71.097 71.097 0 0 0-5.924-5.47 72.458 72.458 0 0 0-10.204-7.026 75.2 75.2 0 0 0-5.98-3.055c-.062-.028-.118-.059-.18-.087-9.792-4.44-22.106-7.529-37.416-7.529s-27.624 3.089-37.416 7.529c-.338.153-.653.318-.985.474a75.37 75.37 0 0 0-6.229 3.298 72.589 72.589 0 0 0-9.15 6.395 71.243 71.243 0 0 0-5.924 5.47 70.064 70.064 0 0 0-3.184 3.527 67.142 67.142 0 0 0-2.609 3.299 63.292 63.292 0 0 0-2.065 2.955 56.33 56.33 0 0 0-1.447 2.324c-.033.056-.073.119-.104.174a47.92 47.92 0 0 0-1.07 1.926c-.559 1.068-.818 1.678-.818 1.678v.398c18.285 17.927 43.322 28.985 70.945 28.985 27.678 0 52.761-11.103 71.055-29.095v-.289s-.619-1.45-1.992-3.778a58.346 58.346 0 0 0-1.446-2.322zM106.002 125.5c2.645 0 5.212-.253 7.68-.737a38.272 38.272 0 0 0 3.624-.896 37.124 37.124 0 0 0 5.12-1.958 36.307 36.307 0 0 0 6.15-3.67 35.923 35.923 0 0 0 9.489-10.48 36.558 36.558 0 0 0 2.422-4.84 37.051 37.051 0 0 0 1.716-5.25c.299-1.208.542-2.443.725-3.701.275-1.887.417-3.827.417-5.811s-.142-3.925-.417-5.811a38.734 38.734 0 0 0-1.215-5.494 36.68 36.68 0 0 0-3.648-8.298 35.923 35.923 0 0 0-9.489-10.48 36.347 36.347 0 0 0-6.15-3.67 37.124 37.124 0 0 0-5.12-1.958 37.67 37.67 0 0 0-3.624-.896 39.875 39.875 0 0 0-7.68-.737c-21.162 0-37.345 16.183-37.345 37.345 0 21.159 16.183 37.342 37.345 37.342z"></path></g></svg>
							<img v-else :src="myProfile.file" alt="Avatar" class="w-32 rounded-full mx-auto" />							
						</div>
						<!-- / -->

						<!-- Is User or Sahabat ZX -->
						<section class="text-center mb-4">
							<vs-button color="warning" size="small" class="rounded-none md:px-8">
								<strong class="text-primary">
									{{ capitalize(myProfile.level.slug) }}
								</strong>
							</vs-button>
						</section>
						<!-- / -->
						</vx-card>
					</div>
					<!-- <vs-button class="rounded-lg w-full bg-white mb-4" size="large" style="border: 1px solid #333">
						<strong class="text-grey">Pilih Foto</strong>
					</vs-button> -->
					<!-- <vs-button class="rounded-lg w-full">
						<strong class="text-white">Keluar</strong>
					</vs-button> -->
					<!-- / -->
				</div>
				<div class="vx-col w-full md:w-2/3">
					<table class="w-full lg:w-3/4 mb-4">
						<tr class="mb-4">
							<th>Member ZX</th>
							<td><strong>{{ myProfile.level ? myProfile.level.name : 'User' }}</strong></td>
						</tr>
						<tr class="mb-4">
							<th>Nama</th>
							<td><strong>{{ myProfile.name ? myProfile.name : '-' }}</strong></td>
						</tr>
						<tr class="mb-4">
							<th>Email</th>
							<td style="overflow: auto"><p class="limit-str"><strong class="limit-str">{{ myProfile.email ? myProfile.email : '-' }}</strong></p></td>
						</tr>
						<tr class="mb-4">
							<th>No. Telepon</th>
							<td><strong>{{ myProfile.no_telp ? myProfile.no_telp : '-' }}</strong></td>
						</tr>
						<tr class="mb-4">
							<th>Status Akun</th>
							<td>
								<strong v-if="myProfile.status === 1" class="text-success">
									Terverifikasi
								</strong>
								<div v-else class="flex items-center">
									<strong class="text-danger mr-4">
										Belum diverifikasi
									</strong>
									<router-link class="text-blue" to="/profile/verify">
										<strong>Verifikasi sekarang?</strong>
									</router-link>
								</div>
								
							</td>
						</tr>
					</table>
					<a href="#" class="px-4 flex items-center" style="color: blue" @click="editProfile">
						<i class="material-icons">edit</i>
						<span class="ml-2">Edit</span>
					</a>
				</div>
			</div>
					
		</div>
	</section>
</template>
<script>
	import { mapState } from 'vuex'

	export default {
		components: {
			MyBalance: () => import('./MyBalance.vue'),
			MyPortalBalance: () => import('./MyPortalBalance.vue')
		},
		data: () => ({
			myProfile: {}
		}),
		methods: {
			editProfile() {
				this.$emit('editProfile')
			}
		},
		computed: {
			...mapState('auth', ['profile'])
		},
		created() {
			Object.assign(this.myProfile, this.profile)
			if(this.myProfile.file !== null) {
				this.myProfile.file = process.env.VUE_APP_STORAGE + '/' + this.myProfile.file
			}
		}
	}
</script>